const API_URL = process.env.VUE_APP_API_URL
const getToken = () => localStorage.getItem('access-token')

export default {
  async getTradeInListAPI (page = 1, search = '') {
    const url = `${API_URL}/v5/admin/trade-in?page=${page}&search=${search}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        }
      })
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return await response.json()
    } catch (error) {
      console.error('Error fetching trade in list:', error)
      throw error
    }
  },

  async getTradeInDetailAPI (upgradeId) {
    const response = await fetch(`${API_URL}/v5/admin/trade-in/${upgradeId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    const resp = await response.json()
    if (!response.ok) {
      if (response.status === 400) throw new Error(resp.error)
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return resp
  },

  async approveDiagnosticAPI (upgradeId) {
    const response = await fetch(`${API_URL}/v5/admin/trade-in/${upgradeId}/diagnostic`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    const resp = await response.json()
    if (!response.ok) throw new Error(resp.error)
    return resp
  },

  async markAsReceivedAPI (upgradeId) {
    const response = await fetch(`${API_URL}/v5/admin/trade-in/${upgradeId}/received`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    const resp = await response.json()
    if (!response.ok) throw new Error(resp.error)
    return resp
  },

  async updateProposalAPI (upgradeId, amount) {
    const response = await fetch(`${API_URL}/v5/admin/trade-in/${upgradeId}/proposal`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      },
      body: JSON.stringify({ amount })
    })
    const resp = await response.json()
    if (!response.ok) throw new Error(resp.error)
    return resp
  },

  async closeTradeInAPI (upgradeId) {
    const response = await fetch(`${API_URL}/v5/admin/trade-in/${upgradeId}/close`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getToken()
      }
    })
    const resp = await response.json()
    if (!response.ok) throw new Error(resp.error)
    return resp
  }
}
